// StyledFilterBar.js
import styled, { css } from 'styled-components';

export const FilterBarContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0px 20px;
    gap: 5px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 52px;
    z-index: 20;

    @media (max-width: 767px) {
        position: sticky;
        top: var(--header-height, 60px);
        padding: 10px 12px 0px 12px;
        gap: 8px;
        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
        border-bottom: 1px solid #f1f1f1;
        z-index: 30;
    }
`;

export const HeaderControlsRow = styled.div`
    // padding: 0 20px;

    @media (max-width: 767px) {
        padding: 0;
    }
`;

export const SpaceDiv = styled.div`
    display: flex;
    justify-content: space-between;
    width: -webkit-fill-available;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #eaeaea;

    @media (max-width: 767px) {
        padding: 8px 0 10px;
        gap: 8px;
        flex-wrap: wrap;
    }
`;

export const FilterGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 8px;
    align-items: center;

    @media (max-width: 767px) {
        gap: 6px;
        align-items: center;
    }
`;

export const Dropdown = styled.select`
    padding: 4px 12px;
    outline: none;
    width: -webkit-fill-available;
    border-radius: 7px;
    border: 1.5px solid var(--F1, #f1f1f1);
`;

const filterDiv = ({ isFilter }) => {
    return isFilter === true
        ? css`
              color: var(--Blue-100, #064274);
              border: 1.5px solid var(--Blue-100, #064274);
              background: var(--Light-Blue, #f0f8ff);

              svg {
                  stroke: var(--Blue-100, #064274) !important;
              }
          `
        : css`
              color: var(--Greyish-Black, #323232);
              background-color: white;
              border: 1.5px solid var(--F1, #f1f1f1);
          `;
};

export const ButtonDiv = styled.div`
    display: flex;
    // padding: var(--10, 10px);
    justify-content: center;
    align-items: center;
    gap: 3px;
    border-radius: 7px;

    cursor: pointer;
    leading-trim: both;
    text-edge: cap;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    ${filterDiv}

    @media (max-width: 767px) {
        min-height: 40px;
        padding: 10px 12px;
        font-size: 13px;
    }
`;

export const Title = styled.label`
    color: var(--Black, #1c1c1c);
    display: inline-flex;
    align-items: center;
    margin: 0;

    /* Title/Large */
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    @media (max-width: 767px) {
        font-size: 16px;
    }
`;

// Additional styled components can be defined here if needed

export const Label = styled.label`
    display: flex;
    padding: var(--10, 10px);
    background-color: white;
    justify-content: center;
    align-items: center;
    gap: 3px;
    border-radius: 7px;
    border: 1.5px solid var(--F1, #f1f1f1);
    cursor: pointer;

    color: var(--Greyish-Black, #323232);
    leading-trim: both;
    text-edge: cap;

    /* Label/Medium */
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const FilterDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 300px;

    @media (max-width: 767px) {
        width: 100%;
    }
`;

export const FilterLabel = styled.label`
    color: var(--Greyish-Black, #323232);
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
`;

export const SortList = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    border: 1px solid #ccc;
    background-color: white;
    z-index: 1;
    border-radius: 7px;
    min-width: 180px;
`;

export const SortContainer = styled.div`
    position: relative;
    user-select: none;
`;

export const SortItem = styled.div`
    padding: 5px 10px;
    cursor: pointer;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: var(--Greyish-Black, #323232);
    /* background-color: white; */
    /* border: 1.5px solid var(--F1, #F1F1F1); */
    font-size: 14px;

    &:hover {
        background-color: #f0f0f0;
    }
`;

export const ButtonWrap = styled.div`
    align-self: end;

    @media (max-width: 767px) {
        align-self: stretch;
    }
`;

export const ClearButton = styled.button`
    background-color: #e45a5c;
    color: white;
    cursor: pointer;
    border-radius: 6px;
    padding: 8px 12px;
    font-weight: 500;
    font-size: 14px;
    border: none;
    min-height: 40px;
    &:hover {
        background-color: #b5373a;
        transition: background-color 0.2s;
    }
`;

export const TabContentHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
`;

export const InlineFiltersWrapper = styled.div`
    padding: 0 0px 20px;

    @media (max-width: 767px) {
        padding: 0;
    }
`;

export const TabHolder = styled.div`
    display: flex;
    flex: 1;
    min-width: 0;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const Tab = styled.button`
    background: none;
    border: none;
    padding: 14px 15px;
    cursor: pointer;
    width: fit-content;
    border-bottom: 2px solid transparent;
    color: var(--Grey, #747474);
    display: flex;
    gap: 3px;
    align-items: center;
    font-weight: 600;

    ${({ active }) =>
        active &&
        `
        color: #064274;
        border-color: #064274;
    `}

    span {
        padding: 3px;
        height: 15px;
        width: 15px;
        font-size: 10px;
        border-radius: 30px;
        background: ${({ active }) => (active ? `var(--Light-Blue, #F0F8FF)` : `#F1F1F1`)};
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @media (max-width: 767px) {
        white-space: nowrap;
        padding: 12px 10px;
        font-size: 13px;
        min-height: 40px;
    }
`;
